var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPillarItem3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29.9999,
    r: 23.2394,
    fill: "#AEC9F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 17C23.2712 17 18 20.075 18 24V36C18 39.925 23.2712 43 30 43C36.7288 43 42 39.925 42 36V24C42 20.075 36.7288 17 30 17ZM40 30C40 31.2025 39.015 32.4288 37.2987 33.365C35.3662 34.4188 32.7738 35 30 35C27.2262 35 24.6337 34.4188 22.7013 33.365C20.985 32.4288 20 31.2025 20 30V27.92C22.1325 29.795 25.7787 31 30 31C34.2213 31 37.8675 29.79 40 27.92V30ZM22.7013 20.635C24.6337 19.5813 27.2262 19 30 19C32.7738 19 35.3662 19.5813 37.2987 20.635C39.015 21.5712 40 22.7975 40 24C40 25.2025 39.015 26.4288 37.2987 27.365C35.3662 28.4187 32.7738 29 30 29C27.2262 29 24.6337 28.4187 22.7013 27.365C20.985 26.4288 20 25.2025 20 24C20 22.7975 20.985 21.5712 22.7013 20.635ZM37.2987 39.365C35.3662 40.4188 32.7738 41 30 41C27.2262 41 24.6337 40.4188 22.7013 39.365C20.985 38.4287 20 37.2025 20 36V33.92C22.1325 35.795 25.7787 37 30 37C34.2213 37 37.8675 35.79 40 33.92V36C40 37.2025 39.015 38.4287 37.2987 39.365Z",
    fill: "#0D2548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillarItem3);
export default __webpack_public_path__ + "static/media/icon-pillar-item-3.519222e6dde5edbda646a9fa4af1cfd1.svg";
export { ForwardRef as ReactComponent };